import script from "./itemV3ShowMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3ShowMore.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__